'use client';

import { useEffect } from 'react';
import * as Sentry from '@sentry/nextjs';
import { useAuth, getAuthUser } from '@/hooks/useAuth';

// Side-effect import to ensure Sentry initializes
// We re-import the config here to force it into the client bundle
import '@/sentry.client.config';

export default function SentryInitializer() {
    const { isAuthenticated } = useAuth(false);

    // Optional: Log to verify it loaded
    useEffect(() => {
        const user = getAuthUser();

        if (user) {
            Sentry.setUser({
                id: user.id,
                email: user.email,
                username: user.name,
                ...user,
            });
        } else {
            Sentry.setUser(null);
        }

        if (process.env.NODE_ENV === 'development') {
            console.log('[Sentry] SentryInitializer loaded');
            console.log('[Sentry] Client initialized:', !!Sentry.getClient());
            if (user) {
                console.log('[Sentry] User set:', user.email);
            }
        }
    }, [isAuthenticated]);

    return null;
}
